import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ExcelImportMode, ExcelImportResult } from '../models/excel-import';

/**
 * Excel mass-import POC. Two separate flows so the business team can compare
 * client experience: `template` (deterministic) and `ai` (free-form file).
 */
@Injectable({
  providedIn: 'root',
})
export class ExcelImportService {
  private http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}/import/excel`;

  /** Flux A — download the .xlsx template to fill in. */
  downloadTemplate(): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.url}/template`, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  /** Upload a spreadsheet and create one draft trip per row. */
  import(mode: ExcelImportMode, file: File): Observable<ExcelImportResult> {
    const formData = new FormData();
    formData.append('document', file);
    return this.http.post<ExcelImportResult>(`${this.url}/${mode}`, formData);
  }
}
